import React from "react";
import { connect } from "react-redux";

import SvgIcon from "@mui/material/SvgIcon";
import EditIcon from '@mui/icons-material/Edit';
import ShareIcon from '@mui/icons-material/Share';
import AssignmentIcon from "@mui/icons-material/Assignment";
import {LookIntroIcon, LookLayoutIcon, LookRoomIdeasIcon} from "../../../common/icons";
import COLOR_THEMES from "../../../../colorThemes";
// import BathroomFeatureGroupsIcons from "../../../common/svgIcons/bathroomFeatureGroupIcons";


const LookIntroBoxIcon = (props) => {

  const {introStep, isMobile, activeTheme} = props;

  switch (introStep) {
    case 0:
    default:
      return (
        <SvgIcon style={{ fontSize: 22 }}>
          <LookIntroIcon/>
        </SvgIcon>
      )
    case 1:
      return <EditIcon/>
    // case 2:
    //   return (
    //     <SvgIcon>
    //       {BathroomFeatureGroupsIcons["shower_wall"]}
    //     </SvgIcon>
    //   )
    case 2:
      return (
        <SvgIcon>
          <LookLayoutIcon/>
        </SvgIcon>
      )
    case 3:
      return <ShareIcon/>
    case 4:
      return isMobile ? (
        <SvgIcon>
          <LookRoomIdeasIcon color={COLOR_THEMES[activeTheme].primary} />
        </SvgIcon>
      ) : <AssignmentIcon/>
    case 5:
      return <AssignmentIcon/>
  }

};

const mapStateToProps = (store) => {
  const {introStep} = store.lookState;
  const {isMobile, activeTheme} = store.serverState;
  return {
    introStep,
    isMobile,
    activeTheme,
  };
};

export default connect(mapStateToProps)(LookIntroBoxIcon)
